import { lazy } from 'react';
import RolesGuard from 'src/components/RolesGuard';
import { PermissionsGuard } from './components';
import {
    CREATE_PERMISSION,
    READ_PERMISSION,
    RECORDING_TESTS_AUTH,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';

export const Routes = [
    {
        exact: true,
        path: '/create/recording-test',
        guard: PermissionsGuard,
        roles: {
            permission: RECORDING_TESTS_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(
            () => import('src/views/recordingTest/RecordingCreateView')
        ),
    },
    {
        exact: true,
        path: '/management/recording-tests/:id/edit',
        guard: PermissionsGuard,
        roles: {
            permission: RECORDING_TESTS_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: lazy(
            () => import('src/views/recordingTest/RecordingEditView')
        ),
    },
    {
        exact: true,
        path: '/management/recording-tests/:id',
        guard: PermissionsGuard,
        roles: {
            permission: RECORDING_TESTS_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(
            () => import('src/views/recordingTest/RecordingDetailsView')
        ),
    },
    {
        exact: true,
        path: '/management/recording-tests',
        guard: PermissionsGuard,
        roles: {
            permission: RECORDING_TESTS_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(
            () => import('src/views/recordingTest/RecordingListView')
        ),
    },
];
